export default __webpack_public_path__ + "static/media/office-building-purple.edd89b41.svg";